export const UNIT_ID = {
    // 디컨 단건결제
    P_PAY_DICON_POINT: 'p_pay_dicon_point',
    // 주문서 PC
    // 충전결제 영역
    P_PAY_PAYMENT_POINT: 'p_pay_payment_point',
    // 계좌간편결제 영역 (PC)
    P_PAY_PAYMENT_BB: 'p_pay_payment_bb',
    // 카드간편결제 영역 (PC)
    P_PAY_PAYMENT_CARD: 'p_pay_payment_card',
    // 일반결제 > 신용카드 영역 (PC)
    P_PAY_PAYMENT_OTHER: 'p_pay_payment_other',
    // 일반결제 > 나중에결제 영역 (PC)
    P_PAY_PAYMENT_LATER: 'p_pay_payment_later',
    // PC 주문완료 paid_center
    P_PAY_PAID_CENTER: 'p_pay_paid_center1',
    // PC 주문완료 팝업
    P_PAY_POPUP_ORDERDONE: 'p_pay_popup_orderdone',
    // PC 하단
    P_PAY_ORDERSHEET_BOTTOM: 'p_pay_ordersheet',
    // 주문서 Mobile
    // 카드 간편결제 영역
    M_PAY_PAYMENT_CARD: 'm_pay_payment_card',
    // 일반결제 > 신용카드 영역
    M_PAY_PAYMENT_OTHER: 'm_pay_payment_other',
    // 일반결제 > 나중에결제 영역
    M_PAY_PAYMENT_LATER: 'm_pay_payment_later',
    // 충전결제 영역
    M_PAY_PAYMENT_POINT: 'm_pay_payment_point',
    // 계좌간편결제 영역
    M_PAY_PAYMENT_BB: 'm_pay_payment_bb',
    // PC 가맹점 주문완료
    PC_PAY_ORDERDONE_MALL: 'pc_pay_orderdone_c1',
    // MO 가맹점 주문완료
    M_PAY_ORDERDONE_MALL: 'm_pay_orderdone_c1',
    // PC 스스 주문완료
    PC_PAY_ORDERDONE_SELLER: 'pc_pay_orderdone',
    // MO 스스 주문완료
    M_PAY_ORDERDONE_SELLER: 'm_pay_orderdone',
    // UNKNOWN
    UNKNOWN: '',
    // 모바일 하단
    M_PAY_ORDERSHEET_BOTTOM: 'm_pay_odersheet',
    // [디컨 - 단건] 페이머니 미가입자 대상 충전결제 하단
    P_PAY_DICON_SINGLE: 'p_pay_dicon_point_single',
    M_PAY_DICON_SINGLE: 'm_pay_dicon_point_single',
    /** [디컨 - 정기] 페이머니 미가입자 대상 광고배너 노출 */
    M_PAY_DICON_POINT_REG: 'm_pay_dicon_point_reg',
    P_PAY_DICON_POINT_REG: 'p_pay_dicon_point_reg',
    // 모바일 주문완료 paid_center
    M_PAY_PAID_CENTER: 'm_pay_paid_center1',
    // 모바일 주문완료 팝업
    M_PAY_POPUP_ORDERDONE: 'm_pay_popup_orderdone',
    // 주문완료 > LeftSection 배너
    M_PAY_PAID_LEFT: 'm_pay_paid_center2',
    P_PAY_PAID_LEFT: 'p_pay_paid_center2',
    // 주문완료 > RightSection 배너
    M_PAY_PAID_RIGHT: 'm_pay_paid_center3',
    P_PAY_PAID_RIGHT: 'p_pay_paid_center3',
    /** 구매확정 완료 */
    M_PAY_PURCHASE_CONFIRMED_1: 'm_pay_purchase_confirmed_1',
    /** 구매확정완료 상품추천광고 */
    M_PAY_PURCHASE_CONFIRMATION_RESULT: 'm_pay_purchasedecision',
    /** [결제상세] 최상단 스마트채널 광고 (오프라인) */
    M_PAYMENT_DETAIL_OFFLINE_SMART_CHANNEL_AD: 'm_pay_paid_end_offline_top',
    P_PAYMENT_DETAIL_OFFLINE_SMART_CHANNEL_AD: 'p_pay_paid_end_offline_top',
    /** [결제상세] 중앙 배너 (온라인) */
    M_PAYMENT_DETAIL_ONLINE_CENTER_AD: 'm_pay_paid_end_nsp',
    P_PAYMENT_DETAIL_ONLINE_CENTER_AD: 'p_pay_paid_end_nsp',
    /** [결제상세] 중앙 배너 (오프라인) */
    M_PAYMENT_DETAIL_OFFLINE_CENTER_AD: 'm_pay_paid_end_offline',
    P_PAYMENT_DETAIL_OFFLINE_CENTER_AD: 'p_pay_paid_end_offline',
    /** [결제상세] 하단 팝업 배너 (온라인) */
    M_PAY_PAID_END_POPUP: 'm_pay_paid_end_popup',
    P_PAY_PAID_END_POPUP: 'p_pay_paid_end_popup',
    /** [결제상세] 하단 팝업 배너 (오프라인) */
    M_PAY_PAID_OFF_END_POPUP: 'm_pay_paid_off_end_popup',
    P_PAY_PAID_OFF_END_POPUP: 'p_pay_paid_off_end_popup',
    /** [결제상세] 하단 팝업 배너 (글로벌) */
    M_PAY_PAID_GLOBAL_END_POPUP: 'm_pay_paid_global_end_popup',
    P_PAY_PAID_GLOBAL_END_POPUP: 'p_pay_paid_global_end_popup',
    /** [주문상세] 스마트채널 광고 */
    M_PAY_ORDERDETAILS_TOP: 'm_pay_orderdetails_top',
    P_PAY_ORDERDETAILS_TOP: 'p_pay_orderdetails_top',
    /** [주문상세] 포인트혜택 하단 GFD 배너 */
    M_PAY_PAID_END: 'm_pay_paid_end',
    P_PAY_PAID_END: 'p_pay_paid_end',
    /** 주문상세 > 쇼핑검색광고 */
    M_PAY_ORDER_DETAIL: 'm_pay_orderdetail',
    PC_PAY_ORDER_DETAIL: 'pc_pay_orderdetail',
    // 정기구독 신청완료 1 - 포인트 혜택 하단 & 버튼 상단
    PC_PAY_SHOPPING_SUBSCRIPTION_RESULT_UNDER_REWARD_POINT: 'p_pay_subscription_done1',
    M_PAY_SHOPPING_SUBSCRIPTION_RESULT_UNDER_REWARD_POINT: 'm_pay_subscription_done1',
    // 정기구독 신청완료 2 - 쇼검광 하단
    PC_PAY_SHOPPING_SUBSCRIPTION_RESULT_UNDER_SHOPPING_AD: 'p_pay_subscription_done2',
    M_PAY_SHOPPING_SUBSCRIPTION_RESULT_UNDER_SHOPPING_AD: 'm_pay_subscription_done2',
    // PC 정기구독 신청완료 3 - aitems 하단
    PC_PAY_SHOPPING_SUBSCRIPTION_RESULT_UNDER_AITEMS: 'p_pay_subscription_done3',
    M_PAY_SHOPPING_SUBSCRIPTION_RESULT_UNDER_AITEMS: 'm_pay_subscription_done3',
    // 정기구독 쇼검광
    PC_PAY_SHOPPING_SUBSCRIPTION: 'p_pay_subscription',
    M_PAY_SHOPPING_SUBSCRIPTION: 'm_pay_subscription',
    // 배송조회 스마트채널
    M_PAY_DELIVERY_TRACKING_SMARTCHANNEL: 'm_pay_parcel_top',
    PC_PAY_DELIVERY_TRACKING_SMARTCHANNEL: 'p_pay_parcel_top',
    // 배송조회 DA배너
    M_PAY_DELIVERY_TRACKING_MID: 'm_pay_parcel_300',
    PC_PAY_DELIVERY_TRACKING_MID: 'p_pay_parcel_300',
    // 배송조회 쇼검광
    M_PAY_DELIVERY_TRACKING_RECOMMENDATION_PRODUCTS: 'm_pay_deliverytracking',
} as const

export type UnitIdType = Constant<typeof UNIT_ID>

export const GladElementId = {
    // 충전결제 영역
    RECHARGE_POINT: 'div-7',
    // 카드 간편결제 영역
    EASY_CARD: 'div-2',
    // 계좌간편결제 영역
    EASY_BANK: 'div-8',
    // 일반결제 > 신용카드 영역
    CARD: 'div-3',
    // 일반결제 > 나중에결제 영역
    PAY_NEXT: 'div-6',
    // PC 가맹점 주문완료
    PC_PAY_ORDERDONE_MALL: 'pc_pay_orderdone_c1',
    // MO 가맹점 주문완료
    M_PAY_ORDERDONE_MALL: 'm_pay_orderdone_c1',
    // PC 스스 주문완료
    PC_PAY_ORDERDONE_SELLER: 'pc_pay_orderdone',
    // MO 스스 주문완료
    M_PAY_ORDERDONE_SELLER: 'm_pay_orderdone',
} as const

export const LoadStatus = {
    IDLE: 'IDLE',
    FETCHING: 'FETCHING',
    SUCCEED: 'SUCCEED',
    FAILURE: 'FAILURE',
} as const

export type LoadStatusType = Constant<typeof LoadStatus>

export type PaymentType = 'recharge-payment' | 'easy-bank-payment' | 'easy-card-payment' | 'normal-payment'
